import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Reactions } from '../reactions/interfaces/reactions.interface';

@Component({
  selector: 'app-news-large-card',
  templateUrl: './news-large-card.component.html',
  styleUrls: ['./news-large-card.component.scss']
})
export class NewsLargeCardComponent {
  private router: Router = inject(Router);


  @Input() public position: 'left' | 'right' = 'right';
  @Input() id: string = '';
  @Input() image: string = '';
  @Input() category: string = '';
  @Input() categoryBackgroundColor: string = '';
  @Input() categoryFontColor: string = '';
  @Input() title: string = '';
  @Input() date: string = '';
  @Input() content: string = '';
  @Input() readingTime: string = '';
  @Input() link: string = '';
  @Input() reactions: Reactions;

  navigateToDetails() {
    console.log('Mostrando detalles de la noticia home:', this.id);
    this.router.navigate(['/noticia', this.id]);
  }

}
